import React, { useMemo } from 'react';
import { Button } from 'primereact/button';
import { Tag } from 'primereact/tag';
import { RadioButton } from 'primereact/radiobutton';
import { useLanguage } from '../../../contexts/LanguageContext';
import DealerPreAccountingTable from './components/DealerPreAccountingTable';
import PreAccountingAddDialog from './components/PreAccountingAddDialog';
import usePreAcoounting from './hooks/usePreAcoounting';
import GenericFileExportButton from '../../../components/common/GenericFileExportButton';
import { useLazyExportPreAccountingQuery } from '../../../api/endpoints/preAccounting';
import { Dropdown } from 'primereact/dropdown';
import PreAccountingFilter from './components/PreAccountingFilter';

const PreAccountingPage = () => {
    const { th } = useLanguage();
    const { customerDropdown, handleSearch, handleAdvanced, handleReset, showHeaderBar, addEnabled, totalBalances, tableProps, addDialog, activeFilters, customerType, setCustomerType } = usePreAcoounting();
    const exportFileName = useMemo(() => {
        const dt = new Date();
        const y = dt.getFullYear();
        const m = String(dt.getMonth() + 1).padStart(2, '0');
        const d = String(dt.getDate()).padStart(2, '0');
        return `PreAccounting_${y}-${m}-${d}`;
    }, []);
    return (
        <div className="card">
            <div className="flex justify-content-between align-items-center mb-4">
                <h1 className="m-0">{th('preAccounting.title')}</h1>
            </div>
            <div className="flex align-items-center gap-4 mb-3">
                <div className="flex align-items-center gap-2">
                    <RadioButton inputId="rbCustomer" name="customerType" value={0} checked={customerType === 0} onChange={(e) => setCustomerType(e.value)} />
                    <label htmlFor="rbCustomer" className="mb-0">
                        {th('preAccounting.customerTypeCustomer')}
                    </label>
                </div>
                <div className="flex align-items-center gap-2">
                    <RadioButton inputId="rbDealer" name="customerType" value={1} checked={customerType === 1} onChange={(e) => setCustomerType(e.value)} />
                    <label htmlFor="rbDealer" className="mb-0">
                        {th('preAccounting.customerTypeDealer')}
                    </label>
                </div>
            </div>
            <div className="col-12">
                <PreAccountingFilter th={th} customerType={customerType} customerDropdown={customerDropdown} onReset={handleReset} onApply={() => handleAdvanced?.({ customer: customerDropdown.value })} initiallyOpen={true} />
            </div>

            {showHeaderBar && (
                <div className="grid mb-3 align-items-end">
                    <div className="col-12 md:col-8">
                        <div className="flex align-items-center gap-3 flex-wrap" style={{ minHeight: 40 }}>
                            {totalBalances.map((balance, index) => (
                                <Tag
                                    key={`${balance.currency}-${index}`}
                                    value={`${th('preAccounting.totalBalance')}: ${balance.amount?.toLocaleString()} ${balance.currency}`}
                                    rounded
                                    className="text-sm px-3 py-2"
                                />
                            ))}
                        </div>
                    </div>
                    <div className="col-12 md:col-4 flex flex-column align-items-end gap-2">
                        <GenericFileExportButton
                            useExportQuery={useLazyExportPreAccountingQuery}
                            exportParams={activeFilters}
                            buttonLabel={th('common.export')}
                            buttonClassName="p-button-outlined"
                            icon="pi pi-file-excel"
                            disabled={tableProps.loading || !tableProps.totalRecords || !activeFilters?.DealerId}
                            fileNameExtractor={(result) => result?.fileName || exportFileName}
                            dataExtractor={(result) => result?.fileBase64}
                            contentTypeExtractor={(result) => result?.contentType}
                            exportFormat="base64"
                        />

                        {customerType === 0 && <Button className="mt-2" label={th('preAccounting.add')} icon="pi pi-plus" severity="success" onClick={addDialog.open} disabled={!addEnabled} />}
                    </div>
                </div>
            )}

            <DealerPreAccountingTable
                th={th}
                data={tableProps.data}
                totalRecords={tableProps.totalRecords}
                lazyParams={tableProps.lazyParams}
                onPage={tableProps.onPage}
                onSort={tableProps.onSort}
                loading={tableProps.loading}
                onEdit={addDialog.openEdit}
            />

            <PreAccountingAddDialog
                th={th}
                visible={addDialog.visible}
                onHide={addDialog.close}
                form={addDialog.form}
                setForm={addDialog.setForm}
                onSave={addDialog.save}
                options={addDialog.options}
                loading={addDialog.loading}
                isEditMode={addDialog.isEditMode}
            />
        </div>
    );
};

export default PreAccountingPage;
